/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as TYPES from './action-types';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';

export const setDeleteCheckLogLoading = (payload) => {
  return {
    type: TYPES.DELETE_CHECK_LOG_LOADING,
    payload,
  };
};

export const setReabteProgramData = (payload) => {
  return {
    type: TYPES.DELETE_CHECK_LOG_REBATE_PROGRAM_DATA,
    payload,
  };
};

export const setDeleteCheckLogFilter = (payload) => {
  return {
    type: TYPES.DELETE_CHECK_LOG_FILTER,
    payload,
  };
};

export const setUserDefault = (payload) => {
  return {
    type: TYPES.DELETE_CHECK_LOG_USERDEFAULT,
    payload,
  };
};

export const resetDeleteCheckLogStore = () => {
  return {
    type: TYPES.DELETE_CHECK_LOG_RESET_STORE,
  };
};

export const setDeleteCheckLogFilterValue = (key, value) => {
  return (dispatch, getState) => {
    const currentDeleteCheckLogFilter = {
      ...getState().sharedState.deleteCheckLog.deleteCheckLogFilter,
    };
    currentDeleteCheckLogFilter[key] = value;
    dispatch(setDeleteCheckLogFilter(currentDeleteCheckLogFilter));
  };
};

export const getUserDefaults = (values) => async (dispatch, getState) => {
  dispatch(setDeleteCheckLogLoading(true));
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_USER_DEFAULTS}?userId=${values}`
    );

    if (response.data && response.data.data) {
      dispatch(setUserDefault(response.data.data));
    } else {
      dispatch(setUserDefault(null));
    }
  } catch (e) {
    dispatch(setUserDefault(null));
  }
  dispatch(setDeleteCheckLogLoading(false));
};

export const getRebateProgramCode = (values) => async (dispatch) => {
  dispatch(setDeleteCheckLogLoading(true));
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`,
      { planType: values }
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      let newData = [];
      response.data.data.forEach((item) => {
        newData.push({
          label: `${item.rebateProgramCd} | ${item.shortDescr}`,
          value: item.rebateProgramCd,
          ...item,
        });
      });
      dispatch(setReabteProgramData(newData));
    } else {
      dispatch(setReabteProgramData([]));
    }
  } catch (e) {
    dispatch(setReabteProgramData([]));
  }
  dispatch(setDeleteCheckLogLoading(false));
};

export const getCheckLogDetails = (
  values,
  successFunc = () => {},
  errorFuc = () => {}
) => {
  return async (dispatch) => {
    dispatch(setDeleteCheckLogLoading(true));
    try {
      const response = await axios.post(
        serviceEndPoint.CHECK_LOG_DETAILS,
        values
      );

      successFunc(response.data || null);
    } catch (e) {
      errorFuc(e?.response?.data || null);
    }
    dispatch(setDeleteCheckLogLoading(false));
  };
};

export const deleteCheckLogDetails = (
  values,
  successFunc = () => {},
  errorFuc = () => {}
) => {
  return async (dispatch) => {
    dispatch(setDeleteCheckLogLoading(true));
    try {
      const response = await axios.post(
        serviceEndPoint.DELETE_CHECK_LOG,
        values
      );

      successFunc(response.data || null);
    } catch (e) {
      errorFuc(e?.response?.data || null);
    }
    dispatch(setDeleteCheckLogLoading(false));
  };
};

export const setErrorMessages = (payload) => {
  return {
    type: TYPES.SET_ERROR_MESSAGES,
    payload,
  };
};
